import ManageImages from './Container/ManageImages';

export default ManageImages;
